import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=42e23a90&scoped=true"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuGroup.vue?vue&type=style&index=0&id=42e23a90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e23a90",
  null
  
)

export default component.exports